/*eslint @typescript-eslint/no-empty-function: "off"*/
import { PureComponent } from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  requireDocument,
  requireDocumentFn,
  requireDocumentInFolder,
  requireDocumentInFolderFn,
} from 'store/providers/providerSlice';
import notify from '../../../../components/Notify';
import LoadingCircleIndicator from '../../../../components/LoadingCircleIndicator/LoadingCircleIndicator';
import Button from '../../../../components/Button/Button';
import HorizentalFolderView from '../HorizentalFolderView/HorizentalFolderView';
import { Header, TwoLevelHeader, TwoLevelHeaderContainer } from './styles';
import { BotContainer, EmptyPlaceHolder } from '../HorizentalFolderView/styles';
import PageCKEditor from '../../../../components/FileManager/ItemsViewer/Quill/PageCkEditor';
import $ from 'jquery';
import { appDispatch, RootState } from 'store/store';
import { IProvider, IProviderItemView } from 'store/providers/providerTypes';
import i18n from '../../../../i18n';
import { Flipper } from 'react-flip-toolkit';

interface IDispatchToProps {
  requireProviderItem: (id: number) => ReturnType<typeof requireDocumentFn>;
  requireDocumentInFolder: (
    id: number
  ) => ReturnType<typeof requireDocumentInFolderFn>;
}

interface IComponentStates {
  loading: boolean;
  folderLoading: boolean;
  errorFetchingFolder: boolean;
  itemsLoaded: boolean;
  loadingHeader: boolean;
  headerContent?: string;
  failedLoadSelf?: boolean;
}

interface IOwnProps {
  folderId: number;
  providerId: number;
  onOpen: (item: IProviderItemView) => void;
  forceSingle?: boolean;
  provider: IProvider | null;
  selectedItem: number | null;
  itemArrangement: Array<{ id: number }>;
  onSelectedItem: (id: number | null) => void;
  onResetItemArrangement: (items: IProviderItemView[]) => void;
  onSelectSpecificItemForArrangement: (item: { id: number }) => void;
  onSetItemArrangement: (items: Array<{ id: number }>) => void;
  folderShowBack?: boolean;
  selectedMoreId: number | null;
  rootFolderId: number | null;
}

interface IStateToProps {
  folder?: IProviderItemView;
  items?: IProviderItemView[];
}

type IComponentProps = IDispatchToProps & IStateToProps & IOwnProps;

class TwoLevelFolderView extends PureComponent<
  IComponentProps,
  IComponentStates
> {
  state = {
    loading: false,
    folderLoading: false,
    errorFetchingFolder: false,
    itemsLoaded: false,
    loadingHeader: false,
    headerContent: undefined,
    failedLoadSelf: undefined,
  };

  componentDidMount(): void {
    this.componentDidUpdate();
  }

  componentDidUpdate(prevProps?: Readonly<IComponentProps>): void {
    const folderIdChanged =
      !prevProps || prevProps.folderId !== this.props.folderId;
    const shouldUpdateArrangement =
      !!this.props.items &&
      this.props.items.length > 0 &&
      (folderIdChanged ||
        (prevProps?.items !== this.props.items &&
          this.props.items.length !== (prevProps?.items?.length || 0)));

    if (
      ((!this.props.folder && !this.state.folderLoading) ||
        !prevProps ||
        prevProps.folderId !== this.props.folderId) &&
      !this.state.errorFetchingFolder
    ) {
      this.loadFolderContent();
      if (!this.props.folder && !this.state.failedLoadSelf) {
        this.loadFolderItSelf();
      }
    }
    if (!prevProps || prevProps!.folderId !== this.props.folderId) {
      this.setState({ itemsLoaded: false });
    }
    const header = this.props.items?.find((a) =>
      a.tags.some((tag) => tag.text === 'CONF_HEADER')
    );
    const url = header?.document?.url;
    if (url && !this.state.headerContent && !this.state.loadingHeader) {
      this.setState({ loadingHeader: true });
      $.get(url, null, ((data: any) => {
        this.setState({ headerContent: data, loadingHeader: false });
      }) as any);
    }

    if (shouldUpdateArrangement) {
      const newArrangement =
        this.props.items &&
        this.props.items
          .sort((a, b) => a.order - b.order)
          .filter(
            (a) =>
              (a.type === 'folder' || a.type === 'searchTag') &&
              !a.tags.some((tag) => tag.text.toLowerCase() === 'conf_hidden')
          )
          .map((item) => ({
            id: item.id,
          }));

      if (newArrangement) {
        this.props.onSetItemArrangement(newArrangement);
      }
    }
  }

  loadFolderItSelf = () => {
    if (this.props.folder) return;
    this.setState({ folderLoading: true });
    this.props.requireProviderItem(Number(this.props.folderId)).then(
      () => {
        this.setState({ folderLoading: false });
      },
      () => {
        this.setState({ folderLoading: false, failedLoadSelf: true });
        notify(i18n.t('networkError', { ns: 'landingPage' }), 'error');
      }
    );
  };

  loadFolderContent = () => {
    this.setState({ loading: true });
    this.props.requireDocumentInFolder(Number(this.props.folderId)).then(
      () => {
        this.setState({
          loading: false,
          itemsLoaded: true,
          headerContent: undefined,
          loadingHeader: false,
        });
      },
      () => {
        notify(i18n.t('networkError', { ns: 'landingPage' }), 'error');
        this.setState({ loading: false });
      }
    );
  };

  getDisplayMode = (viewType: string[] | undefined) => {
    return viewType?.find((it: string) => it === 'display_tinder')
      ? 'tinder'
      : viewType?.find((it: string) => it === 'display_slider')
        ? 'slider'
        : viewType?.find((it: string) => it === 'display_text')
          ? 'text'
          : viewType?.find((it) => it === 'display_xlg')
            ? 'xlg'
            : viewType?.find((it) => it === 'display_lg') ||
                viewType?.some((it: string) => it === 'display_shine')
              ? 'lg'
              : viewType?.find((it) => it === 'display_md')
                ? 'md'
                : 'sm';
  };

  render() {
    const {
      items,
      selectedItem,
      providerId,
      forceSingle,
      folder,
      onSelectedItem,
      itemArrangement,
      onResetItemArrangement,
      onSelectSpecificItemForArrangement,
      folderShowBack,
      selectedMoreId,
      rootFolderId,
    } = this.props;
    const { loading, itemsLoaded, headerContent } = this.state;
    const sorted = items && items.sort((a, b) => a.order - b.order);

    const viewType = folder?.viewType?.split(',');

    const isShine = viewType?.includes('display_shine');
    const folders =
      forceSingle || isShine
        ? []
        : sorted &&
          sorted.filter(
            (a) =>
              (a.type === 'folder' || a.type === 'searchTag') &&
              !a.tags.some((tag) => tag.text.toLowerCase() === 'conf_hidden')
          );
    const others =
      forceSingle || isShine
        ? sorted
        : sorted &&
          sorted.filter(
            (a) =>
              a.type !== 'folder' &&
              a.type !== 'searchTag' &&
              !a.tags.some(
                (tag) =>
                  tag.text.toLowerCase() === 'conf_hidden' ||
                  tag.text === 'CONF_HEADER'
              )
          );
    const header = sorted?.find((a) =>
      a.tags.some((tag) => tag.text === 'CONF_HEADER')
    );

    return loading ? (
      <LoadingCircleIndicator />
    ) : items ? (
      <div>
        <Flipper flipKey={itemArrangement?.map((item) => item.id).join('')}>
          <BotContainer isItemSelected={selectedItem !== null}>
            {folder?.dadId !== rootFolderId ? (
              <TwoLevelHeaderContainer id={'i' + folder?.id}>
                <TwoLevelHeader>{folder?.name ?? undefined}</TwoLevelHeader>
                {folder?.dadId && (
                  <div style={{ width: '140px', height: '1px' }} />
                )}
              </TwoLevelHeaderContainer>
            ) : (
              <div></div>
            )}

            {header && headerContent && (
              <Header>
                <PageCKEditor
                  item={{ data: header }}
                  editing={false}
                  updateContent={() => {
                    /* do nothing
                     */
                  }}
                  saving={false}
                  content={headerContent}
                />
              </Header>
            )}

            {others!.length && folder?.id ? (
              <HorizentalFolderView
                onOpen={this.props.onOpen}
                key={'others'}
                providerId={providerId}
                grid={true}
                shine={isShine}
                directItems={others}
                title={undefined}
                provider={this.props.provider}
                showImage={forceSingle || viewType?.includes('display_shine')}
                itemArrangement={itemArrangement}
                onResetItemArrangement={() =>
                  onResetItemArrangement(folders as IProviderItemView[])
                }
                onSelectItemForItemManagement={
                  onSelectSpecificItemForArrangement
                }
                onSelectedItem={onSelectedItem}
                displayMode={this.getDisplayMode(viewType)}
                folderShowBack={folderShowBack}
                selectedMoreId={selectedMoreId}
                itemFolder={folder?.id}
                // onChangeSelectedMoreId={onChangeSelectedMoreId}
              />
            ) : (
              ''
            )}

            {folders!.map((item: IProviderItemView) => {
              if (itemArrangement.map((item) => item.id).includes(item.id)) {
                const id = item.id;
                const viewType = item?.viewType?.split(',');
                const shine = viewType?.some(
                  (it: string) => it === 'display_shine'
                );
                const displayMode = this.getDisplayMode(viewType);
                return (
                  <HorizentalFolderView
                    onOpen={this.props.onOpen}
                    key={id}
                    folderId={id}
                    grid={
                      (folders!.length === 1 && others!.length === 0) || shine
                    }
                    providerId={providerId}
                    provider={this.props.provider}
                    shine={shine}
                    showImage={shine}
                    itemArrangement={itemArrangement}
                    onResetItemArrangement={() =>
                      onResetItemArrangement(folders as IProviderItemView[])
                    }
                    onSelectItemForItemManagement={
                      onSelectSpecificItemForArrangement
                    }
                    onSelectedItem={onSelectedItem}
                    displayMode={displayMode}
                    folderShowBack={folderShowBack}
                    selectedMoreId={selectedMoreId}
                    rootFolderId={rootFolderId}
                  />
                );
              } else {
                return <></>;
              }
            })}
          </BotContainer>
        </Flipper>
      </div>
    ) : itemsLoaded ? (
      <EmptyPlaceHolder>
        {i18n.t('noMatchFound', { ns: 'landingPage' }) as string}
      </EmptyPlaceHolder>
    ) : (
      <div>
        <p>{i18n.t('networkError', { ns: 'landingPage' }) as string} 2</p>
        <Button onClick={this.loadFolderContent}>
          {i18n.t('tryAgain', { ns: 'landingPage' }) as string}{' '}
        </Button>
      </div>
    );
  }
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const allItems = state.providers.items[Number(props.providerId)].items;
  const virtualChildren = allItems[props.folderId]?.data.virtualChildren;
  const items = Object.values(allItems).reduce(
    (ret: IProviderItemView[], item) => {
      if (
        item.data.dadId === props.folderId ||
        item.data.referenced?.find(
          (link: any) => link.sourceItemId === props.folderId
        ) ||
        virtualChildren?.includes(item.data.id)
      )
        ret.push(item.data);
      return ret;
    },
    [] as IProviderItemView[]
  );
  const folder = props.folderId ? allItems[props.folderId]?.data : undefined;

  return { items: items, folder: folder ?? undefined };
};

const mapDispatchToProps: MapDispatchToProps<IDispatchToProps, IOwnProps> = (
  _,
  props
) => {
  return {
    requireProviderItem: (id: number) =>
      appDispatch(requireDocument({ documentId: id })),
    requireDocumentInFolder: (id: number) =>
      appDispatch(
        requireDocumentInFolder({ folderId: id, providerId: props.providerId })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TwoLevelFolderView);
